import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { DataGridCardProps } from "designSystem/components/dataGrid/DataGrid";
import { ExplorationPinnedImage } from "../../types";
import { Box, Button, CsiImage, FlexColumn } from "designSystem/index";
import { handleOnDragEnd, handleOnDragStart } from "designSystem/dnd/utilities/manage-legacy-dnd";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import styles from "./ExplorationPinnedImagesListItem.module.css";
import { useLocale } from "designSystem/locale";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "designSystem/components/button/IconButton";
import KeepOffIcon from "designSystem/components/icon/KeepOffIcon";

const ExplorationPinnedImagesListItem =  observer(({ item: { image, id } }: DataGridCardProps<ExplorationPinnedImage>) => {
	const loc = useLocale();
	const {
		setSelectedPinnedImageUrl,
		handleOpenNewWizard,
		isNewButtonAvailable,
		handleUnpinExplorationImage,
		newButtonLocType,
	} = useManageFashionInspirationStore();

	const handleOnClick = useCallback(() => {
		setSelectedPinnedImageUrl(image.url);
		handleOpenNewWizard();
	}, [image.url, setSelectedPinnedImageUrl, handleOpenNewWizard]);

	return (
		<Box className={styles.imageWrapper}>
			<CsiImage
				aspectRatio={1}
				borderRadius="4px"
				className={styles.pinnedImage}
				draggable
				onDragEnd={handleOnDragEnd}
				onDragStart={handleOnDragStart}
				src={image.url}
			/>
			<FlexColumn
				alignItems="center"
				className={styles.hoverOverlay}
				justifyContent="flex-end"
				p={2}
			>
				<IconButton
					className={styles.hoverOverlayUnpinButton}
					design="outline"
					onClick={() => handleUnpinExplorationImage(id)}
					size="large"
				>
					<KeepOffIcon />
				</IconButton>
				{ isNewButtonAvailable && (
					<Button
						className={styles.hoverOverlayNewButton}
						design="primary"
						onClick={handleOnClick}
						res="New_Name"
						resParams={[loc.type(newButtonLocType)]}
						startIcon={<AddIcon />}
					/>
				)}
			</FlexColumn>
		</Box>
	);
});

export  default ExplorationPinnedImagesListItem;
